import { useEffect, useRef } from 'react';

/**
 * Прокручивает окно к началу при изменении отслеживаемого значения, пропуская первый рендер.
 * @kind helper
 * @param value - Значение, смена которого означает переход к другому содержимому.
 */
export const useScrollToTopOnChange = (value: unknown) => {
    const previousValue = useRef(value);

    useEffect(() => {
        if (Object.is(previousValue.current, value)) {
            return;
        }

        previousValue.current = value;
        window.scrollTo(0, 0);
    }, [value]);
};
